import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useLocation, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import React from "react";
import localforage from "localforage";
import MDButton from "components/MDButton";
import { useNavigate } from "react-router-dom";
import { Grid } from "@mui/material";
// import BuyModal_iframe from '../components/BuyModal_iframe'
import env from "config";
import { useAppServices } from "hook/services";
import Loader from "examples/Loader";
function Iframs() {
  const navigate = useNavigate();
  const AppService = useAppServices();
  const [app_data, setapp_data] = useState({});
  const [processing, setprocessing] = useState(true);

  const params = useParams();
  const iframeStyles = {
    width: "102.5%",
    height: "calc(100vh - 100px)",
    marginLeft: "-17px",
    marginBottom: "-27px",
    border: "none",
  };

  const getApp = async () => {
    const { response } = await AppService.app.filter({
      query: `_id=${params.id}`,
    });
    if (response) {
      setapp_data(response.data[0]);
      setprocessing(false);
    }
  };

  useEffect(async () => {
    getApp();
  }, []);
  return (
    <DashboardLayout>
      {processing ? (
        <Loader />
      ) : (
        <>
          <Grid justifyContent={"start"} pb={2}>
            <MDButton onClick={() => navigate(-1)}>Go Back</MDButton>
          </Grid>
          <iframe
            style={iframeStyles}
            src={app_data?.preview_link || "https://app.snapshotstore.io"}
          />
        </>
      )}
    </DashboardLayout>
  );
}

export default Iframs;
